import React from "react";
import { CCloseButton, CSidebar } from "@coreui/react";
import { useNav } from "../../context/NavContext";
import { LeftMenu } from "./LeftMenu";
import styled, { createGlobalStyle } from "styled-components";

/* Force CoreUI's sidebar to inherit our dark background */
const SidebarGlobal = createGlobalStyle`
  /* CoreUI sidebar shell */
  .sidebar {
    background: #0d1b3e !important;
    border-right: 1px solid rgba(255,255,255,0.06) !important;
    padding: 0 !important;
  }

  /* Remove CoreUI's default brand/toggler row */
  .sidebar-brand,
  .sidebar-header {
    display: none !important;
  }

  /* Scrollbar */
  .sidebar::-webkit-scrollbar { width: 4px; }
  .sidebar::-webkit-scrollbar-track { background: transparent; }
  .sidebar::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,0.10);
    border-radius: 4px;
  }
`;

const AppSidebar = () => {
  const { sidebarShow, setSidebarShow } = useNav();

  return (
    <>
      <SidebarGlobal />
      <CSidebar
        position="fixed"
        unfoldable={false}
        visible={sidebarShow}
        /* overflow hidden here — LeftMenu's inner MenuScroll handles scrolling */
        style={{ overflow: "hidden", background: "#0d1b3e", border: "none" }}
        onVisibleChange={(visible) => setSidebarShow(visible)}
      >
        {/* Mobile close button — floats over the logo area */}
        <MobileClose>
          <CCloseButton
            className="d-lg-none"
            white
            onClick={() => setSidebarShow(false)}
          />
        </MobileClose>

        <LeftMenu />
      </CSidebar>
    </>
  );
};

export default React.memo(AppSidebar);

/* ─── Styles ──────────────────────────────────────────────── */

const MobileClose = styled.div`
  position: absolute;
  top: 16px;
  right: 12px;
  z-index: 10;
  display: none;

  @media (max-width: 960px) {
    display: flex;
  }
`;

// import React from "react";
// import { CCloseButton, CSidebar } from "@coreui/react";
// import { useNav } from "../../context/NavContext";
// import { stringifyName } from "../../utils/helpers";
// import { useAuth } from "../../context/AuthContext";
// import { LeftMenu } from "./LeftMenu";
// import styled, { keyframes } from "styled-components";
// import { alpha } from "@mui/material";
// import { primaryColor } from "../styled/Theme";

// const AppSidebar = () => {
//   const { sidebarShow, setSidebarShow } = useNav();
//   const { user } = useAuth();
//   const role = user?.role_details?.[0]?.name;

//   return (
//     <CSidebar
//       // className="sidebar-dark bg-theme"
//       position="fixed"
//       unfoldable={false}
//       visible={sidebarShow}
//       style={{ overflow: "scroll", borderRight: "1px solid #eee" }}
//       onVisibleChange={(visible) => {
//         setSidebarShow(visible);
//       }}
//     >
//       <div
//         style={{ borderBottom: "1px solid #eee", position: "relative" }}
//         className="p10"
//       >
//         <div className="flexNullCenter gap10 ">
//           {user?.first_name ? (
//             <>
//               {/* NAME ICON */}
//               <div
//                 className="font25 extraBold primaryColor flexCenter radius10"
//                 style={{
//                   width: 45,
//                   height: 45,
//                   backgroundColor: alpha(primaryColor, 0.1),
//                 }}
//               >
//                 {user.first_name.substring(0, 1)}
//               </div>

//               <div className="flexGrow">
//                 <NameWrapper className="font14 bold">
//                   {stringifyName(user)}
//                 </NameWrapper>
//                 <div className="font12">{role}</div>
//               </div>
//             </>
//           ) : (
//             <>
//               <SkelBone $w="42px" $h="42px" $r="10px" />
//               <div
//                 className="flexGrow"
//                 style={{ display: "flex", flexDirection: "column", gap: 7 }}
//               >
//                 <SkelBone $w="110px" $h="13px" $r="5px" />
//                 <SkelBone $w="68px" $h="10px" $r="5px" $delay="50ms" />
//               </div>
//             </>
//           )}

//           <CCloseButton
//             className="d-lg-none"
//             onClick={() => setSidebarShow(false)}
//           />
//         </div>
//       </div>

//       <LeftMenu />
//     </CSidebar>
//   );
// };

// export default React.memo(AppSidebar);

// const NameWrapper = styled.div`
//   line-height: 1.5;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   overflow: hidden;
//   width: calc(100% - 30px);
// `;

// const sidebarShimmer = keyframes`
//   0%   { background-position: -400px 0; }
//   100% { background-position:  400px 0; }
// `;

// const SkelBone = styled.div<{
//   $w: string;
//   $h: string;
//   $r: string;
//   $delay?: string;
// }>`
//   width: ${(p) => p.$w};
//   height: ${(p) => p.$h};
//   border-radius: ${(p) => p.$r};
//   flex-shrink: 0;
//   animation: ${sidebarShimmer} 1.6s ease-in-out infinite;
//   animation-delay: ${(p) => p.$delay || "0ms"};
//   background: linear-gradient(90deg, #edf1f7 25%, #e2e8f0 50%, #edf1f7 75%);
//   background-size: 400px 100%;
// `;
